import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Article } from '../../classes/article.class';
import { ArticlesService } from '../../services/articles.service';

@Component({
    selector: 'app-article-catalog-management',
    templateUrl: './article-catalog-management.component.html',
    styleUrls: ['./article-catalog-management.component.scss'],
    standalone: false,
})
export class ArticleCatalogManagementComponent {
    private articlesService = inject(ArticlesService);

    readonly articles = toSignal(this.articlesService.getList(), { initialValue: [] });

    update(article: Article, changes: Partial<Pick<Article, 'factor' | 'ai_apply' | 'ai_business_rule'>>): void {
        this.articlesService.update(article.id, changes).subscribe(() => Object.assign(article, changes));
    }
}
